export const SET_STATEPROVINCES = 'SET_STATEPROVINCES'
export const SET_TIMEZONES = 'SET_TIMEZONES'
export const SET_APPLICATIONS = 'SET_APPLICATIONS'
export const SET_APPLICATION = 'SET_APPLICATION'
export const RESET_APPLICATION = 'RESET_APPLICATION'
export const SET_APPLICATION_DATA = 'SET_APPLICATION_DATA'
export const SET_CHECKED = 'SET_CHECKED'
export const SET_PAGER = 'SET_PAGER'
export const RESET_PAGER = 'RESET_PAGER'
export const SET_ASSESSMENTS = 'SET_ASSESSMENTS'
export const SET_ASSESSMENT = 'SET_ASSESSMENT'
export const SET_ASSESSMENT_DATA = 'SET_ASSESSMENT_DATA'
export const RESET_ASSESSMENT = 'RESET_ASSESSMENT'
export const SET_ASSESSMENT_TYPES = 'SET_ASSESSMENT_TYPES'
export const SET_SETTINGS = 'SET_SETTINGS'
export const SET_SETTING = 'SET_SETTING'
export const SET_SETTING_DATA = 'SET_SETTING_DATA'
export const RESET_SETTING = 'RESET_SETTING'
export const SET_NORMS = 'SET_NORMS'
export const SET_BITEMPLATES = 'SET_BITEMPLATES'
export const SET_BITEMPLATE = 'SET_BITEMPLATE'
export const SET_BITEMPLATE_DATA = 'SET_BITEMPLATE_DATA'

export const STORE_PAGER = 'configuration/pager'
export const STORE_STATEPROVINCES = 'configuration/stateprovinces'
export const STORE_TIMEZONES = 'configuration/timezones'
